import { Typography, useTheme } from "@mui/material";
import { FormError } from "../types/FormError";

type Props = {
    error?: FormError
}

const ErrorLabel = ({ error }: Props) => {
    const theme = useTheme();

    if (!error) return null;

    return <Typography variant="caption" sx={{ color: theme.palette.error.main }}>{error.message}</Typography>
}

export default ErrorLabel;